export default {
  apiurl: 'http://reformbanken.reforminstitutet.se/wp/wp-json/wp/v2/'
}



// WEBPACK FOOTER //
// ./src/store/config.js